<template>
	<main>
		<b-modal
			id="slotprefsmodal"
			hide-footer
			hide-header
			size="lg"
			no-close-on-backdrop
			v-model="showSlotModal"
			:centered="isLaptop"
			:modal-class="!isLaptop ? 'bottom-modal' : ''"
			@hidden="closeModal()"
		>
			<main class="d-flex w-100">
				<section class="w-100">
					<header class="candash-modal-top mob-border-bottom-none" :class="isLaptop ? 'p-3' : 'p-2'">
						<div class="width-97 ml-1">
							<div class="candash-modal-head">{{slotEdit ? 'Edit' : 'Setup'}} your Slot Preferences</div>
						</div>
						<div class="d-flex justify-content-end pointer">
							<img
								@click="closeModal()"
								class="rotate-on-hover"
								src="@/assets/newdesign/dashboard/blueCross.svg"
								alt
							/>
						</div>
					</header>
					<section
						class="d-flex mobflex-col slot-pref-modal"
						:style="isLaptop ? 'height: calc(100vh - 275px)' : ''"
					>
						<div
							class="w-50 position-relative pd-slotmodal-left-container mobp-0 mob-br-none mob-w100"
						>
							<div class="pl-3">
								<template v-if="slotLoader">
									<label id="hideinmobile" class="teams-label-font w-40">Your Timezone</label>
									<b-skeleton type="input" class="w-95"></b-skeleton>
								</template>

								<SelectCustom
									v-else
									class="mr-4"
									placeholder="Select Timezone"
									id="panel-slot"
									:values="timezoneOptions"
									:dropdown="true"
									:vmodel="$v.panel.timeZone.$model"
									:showError="$v.panel.timeZone.$error"
									@select-value="$v.panel.timeZone.$model = $event"
									label="Your Timezone"
								/>
								<div v-if="$v.panel.timeZone.$error" class="candash-errortxt errortxt-pos">Required</div>
							</div>
							<hr style="border-top: 1px solid #8c8c8c" class="ml-3 hideinmob" />
							<div class="mt-3 pl-3">
								<div class="color-344054 fs-14 fw-LM fam-mont mb-2">Preference of duration of interviews</div>
								<!-- for the below span when selected bind class selected-slot-time-box instead of slot-time-box and text-blue instead color-3a3c40 and for index1 remove ml-2-->
								<div class="d-flex gap-2" v-if="slotLoader">
									<b-skeleton v-for="i in 3" :key="i" type="input" class="w-20"></b-skeleton>
								</div>
								<span
									v-else
									class="fs-13 fw-LM fam-lato color-3a3c40 ml-2 mt-1 pointer"
									v-for="i in prefDurationOptions"
									:key="i.key"
									@click="panel.interviewDuration = i.key"
									:class="panel.interviewDuration == i.key ? 'selected-slot-time-box' : 'slot-time-box' "
								>{{i.label}}</span>
							</div>
							<hr style="border-top: 1px solid #8c8c8c" class="ml-3" />
							<div class="mr-2 newManage-checkbox pl-3 fs-14">
                                <template v-if="slotLoader">
                                <b-skeleton type="input" class="w-90 mb-2"></b-skeleton>
                                <b-skeleton type="input" class="w-90"></b-skeleton>
                                </template>
                                <template v-else>
								<b-form-checkbox
									id="checkbox-1"
									name="checkbox-1"
									v-model="panel.emailNotification"
									class="dynamic-check"
								>
									Receive Emails for Interview Requests other than Selected
									Timings
								</b-form-checkbox>
								<b-form-checkbox
									id="checkbox-2"
									name="checkbox-2"
									v-model="panel.whatsappNotification"
									class="dynamic-check mt-2"
								>Receive WhatsApp Messages</b-form-checkbox>
                                </template>
							</div>
							<div class="slotpref-notebox text-darkgrey fs-16 fw-LM fam-lato hideinmob">
								To maximize candidate availability, share your availability
								between 9:00 AM and 7:00 PM
							</div>
						</div>
						<div class="w-50 ml-3 mt-3 mob-w100 mobmt-0">
							<div class="text-black fam-lato fw-LM fs-16 pr-3">
								Share Availablity
							</div>
							<div class="text-tertiary fs-14 fw-LM fam-mont pr-3">
								Share your availability to receive interview requests.
							</div>
							<section class="h-89 overflow-xh-ya pr-4 mob-avail-container">
								<div v-for="(timeSlots, day) in panel.availableTimingSlots" :key="day">
									<b-row
										v-for="(singleSlot, index) in timeSlots"
										:key="day + index"
										class="mt-4 mobw-100"
										:id="day + index"
									>
										<b-col cols="3" class="d-flex justify-content-center mobp-0">
											<div
												v-if="index == 0"
												class="h-30px p4-14 w-auto slot-time-box color-6E6E6E fs-13 fw-LM fam-lato"
											>{{day.substring(0,3)}}</div>
										</b-col>
										<b-col
											:id="day + index + 'startTime'"
											cols="3"
											class="d-flex justify-content-center pr-0 mobpl-0 mob-pad"
										>
											<b-skeleton
												v-if="slotLoader"
												type="input"
												class="w-100"
											></b-skeleton>
											<DateField
												v-else
												id="slot-startTime"
												:noLabel="true"
												:isLaptop="isLaptop"
												type="time"
												placeholder="Select"
												:vmodel="singleSlot.startTime"
												format="hh:mm a"
												:minuteStep="minuteInterval"
												:showError="missingSlot[day + index + 'startTime']"
												@select-value="
													(singleSlot.startTime = $event),
														isStartTimeValid(
															day + index + 'startTime',
															day + index + 'endTime',
															singleSlot
														),
														checkForOverLapping(timeSlots, day)
												"
											/>
											<!-- <date-picker
												v-model="singleSlot.startTime"
												format="hh:mm a"
												value-type="format"
												type="time"
												placeholder="Select"
												@input="isStartTimeValid(singleSlot)"
												:minute-step="minuteInterval"
											></date-picker>-->

											<!-- :disabled-time="(date) => disableTimeRange(date, day)" -->

											<!-- <div
												class="p4-14 h-30px w-100px text-center slotpref-selectbox color-6E6E6E fs-13 fw-LM fam-lato"
											>

												09:30 AM
											</div>-->
										</b-col>
										<b-col cols="1" class="px-0 d-flex justify-content-center">
											<img src="@/assets/paneldashboard/borderline.svg" style="width: 65%" alt />
										</b-col>
										<b-col
											:id="day + index + 'endTime'"
											cols="3"
											class="d-flex justify-content-center pl-0 mob-pr-0 mob-pad"
										>
											<b-skeleton
												v-if="slotLoader"
												type="input"
												class="w-100"
											></b-skeleton>

											<DateField
												v-else
												id="slot-endTime"
												:noLabel="true"
												type="time"
												placeholder="Select"
												:vmodel="singleSlot.endTime"
												format="hh:mm a"
												:minuteStep="minuteInterval"
												:startTime="singleSlot.startTime"
												:disabled="!singleSlot.startTime && !singleSlot.endTime"
												:showError="missingSlot[day + index + 'endTime']"
												@select-value="
													(singleSlot.endTime = $event),
														checkEndValidations(day + index, singleSlot),
														checkForOverLapping(timeSlots, day)
												"
											/>
											<div
												v-if="index == timeSlots.length - 1 && overLapData[day]"
												class="candash-errortxt p-check"
											>
												Time slots overlapping
											</div>
											<!-- <template v-if="hasValidTimeSlot && !hasMissingTimeSlotVal">
										<div v-if="index == timeSlots.length -1 && invalidData[day]" class="candash-errortxt p-check">Time slots overlapping</div>
									</template> -->
											<!-- <date-picker
												:disabled="!singleSlot.startTime"
												v-model="singleSlot.endTime"
												format="hh:mm a"
												value-type="format"
												type="time"
												placeholder="Select"
												:disabled-time="(date) => disableBeforeTime(date, singleSlot.startTime)"
											></date-picker>-->
											<!-- <div
												class="p4-14 h-30px w-100px text-center slotpref-selectbox color-6E6E6E fs-13 fw-LM fam-lato"
											>
												Select
											</div>-->
										</b-col>
										<b-col cols="2" class="mob-pad-8">
											<div class="d-flex align-items-center">
												<img
													v-if="index != 0"
													@click="removeSlot(timeSlots, index, day)"
													src="@/assets/paneldashboard/circle-remove.svg"
													class="pointer"
													alt
												/>
												<template v-else>
													<img
														:class="checkAnyEmpty(timeSlots) && 'disabled-download'"
														src="@/assets/paneldashboard/circle-plus.svg"
														@click="!checkAnyEmpty(timeSlots) ? addSlot(day) : ''"
														class="pointer"
														alt
													/>
													<img
														v-if="!hasValidData(timeSlots)"
														src="@/assets/paneldashboard/circle-copy.svg"
														class="disabled-download"
														alt
													/>
													<div
														v-if="hasValidData(timeSlots)"
														class="position-relative"
														tabindex="0"
													>
														<Popper
															trigger="clickToToggle"
															:key="reRender"
															:options="{
																preventOverflow: {
																	enabled: true,
																	boundariesElement: 'viewport',
																},
																eventsEnabled: false,
															}"
															@hide="isLaptop ? clearApply() : ''"
														>
														<template slot="reference">
																<img
																	@click="applyToAll(day, timeSlots)"
																	src="@/assets/paneldashboard/circle-copy.svg"
																	class="pointer"
																	alt
																/>
																</template>
															<template>
																<article
																	@click.stop
																	class="slot-dropdown"
																	id="hideinmobile"
																>
																	<div
																		class="fam-mont fs-13 fw-M text-3A3C40 p-2"
																	>
																		Copy Times to:
																	</div>
																	<div class="pointer newManage-checkbox">
																		<b-form-checkbox-group
																			id="checkbox-group-1"
																			v-model="selected"
																			:options="getFormattedOptions"
																			class="w-100"
																			name="flavour-1"
																		></b-form-checkbox-group>
																	</div>
																	<div
																		:class="{
																			'disabled-download': selected.length == 0,
																		}"
																		@click="
																			selected.length != 0
																				? applyDataToAllDays()
																				: ''
																		"
																		class="pointer blue-back p-2"
																	>
																		<span class="fam-lato fs-13 fw-LM text-blue"
																			>Apply</span
																		>
																		<img
																			src="@/assets/paneldashboard/rightArrow.svg"
																			alt
																		/>
																	</div>
																</article>
															</template>
														</Popper>
													</div>
												</template>
											</div>
										</b-col>
									</b-row>

									<hr
										class="mb-2"
										:class="overLapData[day] && 'mt-4'"
										style="border-top: 1px solid #8c8c8c"
									/>
								</div>
							</section>
						</div>
					</section>
					<div
						class="slotpref-notebox text-darkgrey fs-14 fw-LM fam-lato hideinlaptop"
					>
						To maximize candidate availability, share your availability between
						9:00 AM and 7:00 PM
					</div>
					<footer
						class="candash-modal-footer d-flex align-items-center justify-content-end"
					>
						<div class="d-flex align-items-center gap-3">
							<b-button
								class="candash-cancelBtn pointer"
								@click="resetSlotData(), closeModal()"
							>{{ slotEdit ? 'Cancel' : 'Skip'}}</b-button>
							<div class="position-relative">
								<b-button
									class="candash-addBtn"
									:class="
						                LoaderStatus && slotEdit ? 'loader-class-update defaultCursor' : LoaderStatus ?  'loader-class-mobapply-save defaultCursor' : ''
					                "
									@click="saveSlotData()"
								>{{ LoaderStatus ? "" : slotEdit ? 'Update' : "Save" }}</b-button>
								<div v-if="LoaderStatus" class="loader-pos-new">
									<Loader />
								</div>
							</div>
						</div>
					</footer>
				</section>
			</main>
		</b-modal>

		<!-- modal for apply to all in mobile -->
		<b-modal
			id="showMobileSelect"
			hide-footer
			hide-header
			no-close-on-backdrop
			modal-class="bottom-modal"
			@hidden="clearApply()"
		>
			<div class="d-flex justify-content-between align-items-center px-3 pt-3">
				<div class="d-flex align-items-center fam-mont fs-16 fw-M text-black gap-2">
					<img @click="clearApply()" src="@/assets/paneldashboard/blackBack.svg" alt />
					Copy Times to
				</div>

				<img
					class="rotate-on-hover"
					@click="clearApply()"
					src="@/assets/newdesign/dashboard/blueCross.svg"
					alt
				/>
			</div>
			<div class="d-flex flex-wrap gap-2 p-4 fam-lato fw-LM fs-13">
				<article
					:class="selected.includes(i.value) ? 'slot-sel' : 'slot-unsel'"
					v-for="i in getFormattedOptions"
					@click="selectSlot(i)"
					:key="i.value"
				>{{i.text}}</article>
			</div>
			<footer class="candash-modal-footer d-flex align-items-center justify-content-end">
				<b-button
					class="candash-addBtn"
					:disabled="selected.length == 0"
					@click="selected.length != 0 ? applyDataToAllDays() : ''"
				>Save</b-button>
			</footer>
		</b-modal>
	</main>
</template>

<script>
import SelectCustom from "@/components/InputComponents/SelectCustom.vue";
import { setPanelSlot, getPanelSlot } from "@/utils/apiFunctions";
import toast from "@/components/mixin/toast";
import { required } from "vuelidate/lib/validators";
import Loader from "@/components/fixedcomponents/Loader.vue";
import DateField from "@/components/InputComponents/DateField.vue";
import Popper from "vue-popperjs";
export default {
	name: "SlotPreferenceModal",
	props: {
		showSlotModal: Boolean,
		isLaptop: Boolean,
		slotDataVal: Object,
	},
	data() {
		return {
			overLapData: {},
			slotData: {},
			missingSlot: {},
			options: [
				{ text: "Mon", value: "Monday" },
				{ text: "Tue", value: "Tuesday" },
				{ text: "Wed", value: "Wednesday" },
				{ text: "Thu", value: "Thursday" },
				{ text: "Fri", value: "Friday" },
				{ text: "Sat", value: "Saturday" },
				{ text: "Sun", value: "Sunday" },
			],
			prefDurationOptions: [
				{
					key: "30",
					label: "30 Minutes",
				},
				{
					key: "60",
					label: "1 Hour",
				},
				{
					key: "90",
					label: "2 Hours",
				},
			],
			timezoneOptions: [
				{
					key: "IST",
					label: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
				},
				// { key: "UTC", label: "(UTC) Coordinated Universal Time" },
				// {
				// 	key: "EST",
				// 	label: "(UTC-05:00) Eastern Standard Time (US & Canada)",
				// },
				// {
				// 	key: "EDT",
				// 	label: "(UTC-04:00) Eastern Daylight Time (US & Canada)",
				// },
				// {
				// 	key: "CST",
				// 	label: "(UTC-06:00) Central Standard Time (US & Canada)",
				// },
				// {
				// 	key: "CDT",
				// 	label: "(UTC-05:00) Central Daylight Time (US & Canada)",
				// },
				// {
				// 	key: "MST",
				// 	label: "(UTC-07:00) Mountain Standard Time (US & Canada)",
				// },
				// {
				// 	key: "MDT",
				// 	label: "(UTC-06:00) Mountain Daylight Time (US & Canada)",
				// },
				// {
				// 	key: "PST",
				// 	label: "(UTC-08:00) Pacific Standard Time (US & Canada)",
				// },
				// {
				// 	key: "PDT",
				// 	label: "(UTC-07:00) Pacific Daylight Time (US & Canada)",
				// },
				// { key: "BST", label: "(UTC+01:00) British Summer Time (UK)" },
				// { key: "CET", label: "(UTC+01:00) Central European Time" },
				// { key: "CEST", label: "(UTC+02:00) Central European Summer Time" },
				// { key: "EET", label: "(UTC+02:00) Eastern European Time" },
				// { key: "EEST", label: "(UTC+03:00) Eastern European Summer Time" },
				// { key: "JST", label: "(UTC+09:00) Japan Standard Time" },
				// { key: "KST", label: "(UTC+09:00) Korea Standard Time" },
				// { key: "HKT", label: "(UTC+08:00) Hong Kong Time" },
				// { key: "SGT", label: "(UTC+08:00) Singapore Time" },
				// { key: "AEST", label: "(UTC+10:00) Australian Eastern Standard Time" },
				// { key: "AEDT", label: "(UTC+11:00) Australian Eastern Daylight Time" },
				// { key: "ACST", label: "(UTC+09:30) Australian Central Standard Time" },
				// { key: "ACDT", label: "(UTC+10:30) Australian Central Daylight Time" },
				// { key: "AWST", label: "(UTC+08:00) Australian Western Standard Time" },
				// { key: "NZST", label: "(UTC+12:00) New Zealand Standard Time" },
				// { key: "NZDT", label: "(UTC+13:00) New Zealand Daylight Time" },
				// { key: "AST", label: "(UTC-04:00) Atlantic Standard Time" },
				// { key: "NST", label: "(UTC-03:30) Newfoundland Standard Time" },
				// { key: "HST", label: "(UTC-10:00) Hawaii Standard Time" },
				// { key: "AKST", label: "(UTC-09:00) Alaska Standard Time" },
				// { key: "AKDT", label: "(UTC-08:00) Alaska Daylight Time" },
				// { key: "WET", label: "(UTC+00:00) Western European Time" },
				// { key: "WEST", label: "(UTC+01:00) Western European Summer Time" },
				// { key: "SAST", label: "(UTC+02:00) South Africa Standard Time" },
				// { key: "MSK", label: "(UTC+03:00) Moscow Standard Time" },
				// { key: "SAMT", label: "(UTC+04:00) Samara Time" },
				// { key: "IRST", label: "(UTC+03:30) Iran Standard Time" },
				// { key: "ICT", label: "(UTC+07:00) Indochina Time" },
				// { key: "MST (China)", label: "(UTC+08:00) China Standard Time" },
			],
			panel: {
				timeZone: "IST",
				interviewDuration: "30",
				emailNotification: false,
				whatsappNotification: false,
				availableTimingSlots: null,
			},
			minuteInterval: 10,
			selected: [],
			selectedSlot: [],
			invalidData: {},
			showApplyToAll: null,
			LoaderStatus: false,
			slotEdit: false,
			slotLoader: false,
			reRender: 0,
		};
	},
	mixins: [toast],
	components: {
		SelectCustom,
		Loader,
		DateField,
		Popper,
	},
	validations() {
		return {
			panel: {
				timeZone: {
					required,
				},
				// interviewDuration: {
				// 	required,
				// }
			},
		};
	},
	created() {
		this.setAvailableTimingSlots();
		if (this.slotDataVal) {
			this.slotData = JSON.parse(JSON.stringify(this.slotDataVal));
			this.getSlotData();
		}
	},
	computed: {
		//check if there exists at least one time slot
		hasValidTimeSlot() {
			return Object.values(this.panel.availableTimingSlots).some((slots) =>
				slots.some((slot) => slot.startTime && slot.endTime)
			);
		},
		//check if any time is missing in a slot
		//get formatted option for apply to all (excluding current day)
		getFormattedOptions() {
			return this.options.filter((obj) => obj.value !== this.showApplyToAll);
		},
		hasMissingTimeSlotVal() {
			return Object.values(this.panel.availableTimingSlots).some((slots) =>
				slots.some(
					(slot) =>
						(slot.startTime && !slot.endTime) ||
						(!slot.startTime && slot.endTime)
				)
			);
		},
	},
	methods: {
		removeEeachEmptySlots(slotData) {
			let slots = JSON.parse(JSON.stringify(slotData));
			console.log(slots.filter((slot) => slot.startTime && slot.endTime));
			return slots.filter((slot) => slot.startTime && slot.endTime);
		},
		checkBothSlotsEmpty(slotData) {
			let slots = JSON.parse(JSON.stringify(slotData));
			return slots.filter((slot) => !slot.startTime || !slot.endTime);
		},
		checkForOverLapping(slotData, day) {
			let slots = this.removeEeachEmptySlots(slotData);
			if (slots.length == 1) {
				delete this.overLapData[day];
				this.$forceUpdate();
				return;
			}
			slots.sort(
				(a, b) => this.parseTime(a.startTime) - this.parseTime(b.startTime)
			);
			// check for overlaps
			let hasOverlap = false;
			for (let i = 0; i < slots.length - 1; i++) {
				let currentEnd = this.parseTime(slots[i].endTime);
				let nextStart = this.parseTime(slots[i + 1].startTime);
				if (currentEnd > nextStart) {
					console.log("overlapped");
					this.overLapData[day] = true;
					this.$forceUpdate();
					console.log(this.overLapData);
					hasOverlap = true;
					break;
				} else {
					delete this.overLapData[day];
					this.$forceUpdate();
				}
			}
			// console.log(hasOverlap, 'ovalpp')
			// if(hasOverlap) {
			// 	this.overLapData[day] = true;
			// 	this.$forceUpdate();
			// }
			// else delete this.overLapData[day];
		},
		checkEndValidations(id, slot) {
			this.checkForStartTime(id + "startTime", slot);
			this.checkForEndTime(id + "endTime", slot);
		},
		checkForStartTime(keyValue, slot) {
			if (slot.startTime || (!slot.endTime && !slot.startTime))
				delete this.missingSlot[keyValue];
			else if (slot.endTime) this.missingSlot[keyValue] = true;
		},
		checkForEndTime(keyValue, slot) {
			if (slot.endTime || (!slot.endTime && !slot.startTime))
				delete this.missingSlot[keyValue];
			else if (slot.startTime) this.missingSlot[keyValue] = true;
		},
		hasMissingTimeSlot() {
			let firstError = null;
			let missingSlotVals = {};
			Object.entries(this.panel.availableTimingSlots).map(([day, slots]) => {
				slots.map((slot, index) => {
					if (
						(slot.startTime && !slot.endTime) ||
						(!slot.startTime && slot.endTime)
					) {
						if (!slot.startTime) {
							this.missingSlot[day + index + "startTime"] = missingSlotVals[
								day + index + "startTime"
							] = true;
						}
						if (!slot.endTime) {
							this.missingSlot[day + index + "endTime"] = missingSlotVals[
								day + index + "startTime"
							] = true;
						}
						this.$forceUpdate();
						const keys = Object.keys(missingSlotVals);
						firstError = keys[0];
					}
				});
			});
			this.scrollToCol(firstError);
		},
		scrollToCol(id) {
			console.log(id);
			let idValue;
			if (id.endsWith("endTime")) idValue = id.split("endTime")[0];
			else idValue = id.split("startTime")[0];
			const element = document.getElementById(idValue);
			element.scrollIntoView({ behavior: "smooth" });
		},
		clearApply() {
			this.reRender++;
			this.showApplyToAll = null;
			this.selectedSlot = [];
			this.selected = [];
			this.$bvModal.hide("showMobileSelect");
		},
		//check if start time is greater than endtime , if yes remove endTime
		isStartTimeValid(startKey, endKey, slot) {
			if (slot.startTime && slot.endTime)
				if (this.parseTime(slot.startTime) >= this.parseTime(slot.endTime)) {
					slot.endTime = null;
				}
			this.checkForEndTime(endKey, slot);
			this.checkForStartTime(startKey, slot);
		},
		//initialize available time slots data for each day
		setAvailableTimingSlots() {
			const days = [
				"Monday",
				"Tuesday",
				"Wednesday",
				"Thursday",
				"Friday",
				"Saturday",
				"Sunday",
			];
			this.panel.availableTimingSlots = days.reduce((acc, day) => {
				acc[day] = [{ startTime: null, endTime: null }];
				return acc;
			}, {});
		},
		//check if the given slots consist of both starttime and endtime
		hasValidData(slots) {
			return slots.every((slot) => slot.startTime && slot.endTime);
		},
		closeModal(type) {
			let typeVal = type ? type : null;
			this.$emit("close-modal", typeVal);
		},
		//convert time  into minutes
		parseTime(timeStr) {
			let [time, period] = timeStr.split(" ");
			let [hours, minutes] = time.split(":").map(Number);

			if (period.toLowerCase() === "pm" && hours !== 12) {
				hours += 12;
			} else if (period.toLowerCase() === "am" && hours === 12) {
				hours = 0;
			}
			return hours * 60 + minutes; // Convert to total minutes for easy comparison
		},
		//check if any slots are overlapping in each day
		checkOverlappingSlots(slot) {
			let availableTimingSlots = slot;
			let result = {};
			Object.keys(availableTimingSlots).forEach((day) => {
				let slots = availableTimingSlots[day];
				slots.sort(
					(a, b) => this.parseTime(a.startTime) - this.parseTime(b.startTime)
				);
				// check for overlaps
				let hasOverlap = false;
				for (let i = 0; i < slots.length - 1; i++) {
					let currentEnd = this.parseTime(slots[i].endTime);
					let nextStart = this.parseTime(slots[i + 1].startTime);
					if (currentEnd > nextStart) {
						hasOverlap = true;
						break;
					}
				}
				result[day] = hasOverlap;
			});
			return result;
		},
		checkSlotEmpty(slot) {
			return !slot.startTime && !slot.endTime;
		},
		//select days to apply a selected slot
		selectSlot(i) {
			if (!i.disabled) {
				let index = this.selected.indexOf(i.value);
				if (index == -1) this.selected.push(i.value);
				else this.selected.splice(index, 1);
			}
		},
		//close apply to all dropdown
		closeDropdownOnFocusOut(event, value) {
			let containerSelector = ".customSelect" + value;
			let dropdownElement = document.querySelector(containerSelector);
			if (
				this.isLaptop &&
				event.relatedTarget &&
				!dropdownElement.contains(event.relatedTarget)
			) {
				this.clearApply();
			}
		},
		//reset panel slot data
		resetSlotData() {
			this.panel = {
				timeZone: "IST",
				interviewDuration: "30",
				emailNotification: false,
				whatsappNotification: false,
				availableTimingSlots: null,
			};
			this.setAvailableTimingSlots();
		},
		//remove slot
		removeSlot(timeSlots, index, day) {
			timeSlots.splice(index, 1);
			this.checkForOverLapping(timeSlots, day);
			this.$forceUpdate();
		},
		//check if any slot time is empty
		checkAnyEmpty(availableTimingSlots) {
			return availableTimingSlots.some(
				(item) => !item.startTime || !item.endTime
			);
		},
		//show apply to all modal
		applyToAll(value, timeSlots) {
			this.selectedSlot = timeSlots;
			if (this.showApplyToAll == value) this.showApplyToAll = null;
			else this.showApplyToAll = value;
			if (!this.isLaptop) this.$bvModal.show("showMobileSelect");
		},
		//add a new slot
		addSlot(day) {
			this.panel.availableTimingSlots[day].push({
				startTime: null,
				endTime: null,
			});
		},
		//apply selected slots to all days
		applyDataToAllDays() {
			Object.keys(this.panel.availableTimingSlots).forEach((day) => {
				if (this.selected.includes(day)) {
					let newSlotVal = this.selectedSlot.map(({ startTime, endTime }) => ({
						startTime,
						endTime,
					}));
					if (
						this.panel.availableTimingSlots[day].length == 1 &&
						this.checkSlotEmpty(this.panel.availableTimingSlots[day][0])
					)
						this.panel.availableTimingSlots[day] = newSlotVal;
					else
						this.panel.availableTimingSlots[day] = [
							...this.panel.availableTimingSlots[day],
							...newSlotVal,
						];
					this.checkForOverLapping(this.panel.availableTimingSlots[day], day);
				}
			});

			this.clearApply();
		},
		//remove empty slots if any exists
		removeEmptySlots() {
			let slots = JSON.parse(JSON.stringify(this.panel.availableTimingSlots));
			Object.keys(slots).forEach((day) => {
				slots[day] = slots[day].filter(
					(slot) => !(!slot.startTime && !slot.endTime)
				);
				if (
					slots[day].length === 0 ||
					slots[day].every((slot) => Object.keys(slot).length === 0)
				) {
					delete slots[day];
				}
			});
			return slots;
		},
		//api to save slots
		async saveSlotData() {
			let slots = this.removeEmptySlots();
			this.$v.$touch();
			if (
				this.hasMissingTimeSlotVal &&
				Object.keys(this.overLapData).length != 0
			) {
				this.hasMissingTimeSlot();
				this.errorModal(
					"Error",
					"Slots are missing and some slots are overlapping!"
				);
			} else if (this.hasMissingTimeSlotVal) {
				this.hasMissingTimeSlot();
				this.errorModal("Error", "Slots are missing");
			} else {
				if (Object.keys(this.overLapData).length != 0) {
					this.errorModal("Error", "Slots are overlapping!");
				} else if (!this.$v.$invalid) {
					this.LoaderStatus = true;
					try {
						let payload = JSON.parse(JSON.stringify(this.panel));
						payload.availableTimingSlots = Object.keys(slots).reduce(
							(acc, key) => {
								acc[key.toLowerCase()] = slots[key];
								return acc;
							},
							{}
						);
						const res = await setPanelSlot(payload);
						if (res.status == 200) {
							this.resetSlotData();
							this.closeModal(true);
						} else {
							this.errorModal("Something went wrong!");
						}
					} catch (error) {
						this.errorModal("Something went wrong!");
						console.log(error);
					} finally {
						this.LoaderStatus = false;
						this.invalidData = {};
					}
				}
			}
			},
		//get slots
		getSlotData() {
			this.slotLoader = true;
			this.slotEdit = true;
						let timeslots = this.slotData.availableTimingSlots;
						timeslots = Object.keys(timeslots).reduce((acc, key) => {
							acc[key.charAt(0).toUpperCase() + key.slice(1)] = timeslots[key];
							return acc;
						}, {});
						this.panel = this.slotData;
						this.setAvailableTimingSlots();
						Object.keys(timeslots).forEach((day) => {
							this.panel.availableTimingSlots[day] = timeslots[day];
						});
						this.panel.timeZone = "IST";
					this.slotLoader = false;
		},
	},
};
</script>

<style>
@media (min-width: 1029px) {
	#slotprefsmodal .modal-content {
		top: 30px;
	}
}
</style>
